export enum SortColumnType {
	Integer = 'Integer',
	String = 'String',
	Custom = 'Custom',
}